import React, {Component} from "react";
import PublicNavBar from "../../layouts/Home/HomeElements/PublicNavBar";
import PublicFooter from "../../layouts/Home/HomeElements/PublicFooter";
import styled from "styled-components";
import ShakaPlayer from "../../components/Letflow/ShakaPlayer";
import {makeFitImageUrl, makeFitImageUrlWithSize, makeWaveformUrl} from "../../utils";
import EmbededContent from "../../layouts/Home/ContentCreator/EmbededContent";
import {makeImageUrlWithSize} from "../../layouts/Home/HomeElements/utils";
import {makeImageCarousel} from "../../layouts/Home/HomeElements/HomeElementCarouselItem";
import NoProfile from "../../assets/img/default-avatar.png";
import Link from "react-router-dom/Link";
import {homePathGenerator} from "../../api-client/core/authentication/utils";
import {request} from "../../api-client";
import browserHistory from "../../utils/browserHistory";
import localization from "../../config/localization";
import SoundBar from "../../sound-bar/SoundBar";

class PublicContentCreation extends Component {
  state = {
    currentContentCreation: null,
    playing: false,
    failedLink: false
  };

  soundbarRef = null

  componentDidMount =() => {
    request.contentCreation.getPublic(this.props.match.params.contentCreationId)
      .then(response => this.setState({ currentContentCreation: response}))
      .catch(() => this.setState({failedLink: true}));
  }

  getAudio = (track) => {
    return {
      fetchAudioUrl: () => Promise.resolve(track.audio.url),
      title: track.title,
      subtitle: track.contentCreator.name,
      image: makeImageUrlWithSize(track.contentCreator, 'sm'),
      waveform: makeWaveformUrl(track),
      onSubtitleClick: () => browserHistory.push(homePathGenerator( `public/content_creators/${track.contentCreator.hashcode}`))
    }
  };


  render = () => {
    let { currentContentCreation } = this.state

    if (this.state.failedLink) {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "80vh",
          background: "white",
          width: "90%",
          borderRadius: "1%",
          margin: "0 5%",
          marginTop: "90px",
        }}>
          <p style={{fontSize: 30}}>{localization.get('error.expired_link')}</p>
        </div>)
    }

    return (
      <div id={"inner"} style={{backgroundColor: "rgb(127, 127, 127)"}}>
        <PublicNavBar  contentCreatorView={true} />
        <div style={{height: "100%",minHeight: "90vh"}}>
          <RespD>
            {currentContentCreation &&
              <>
                <div className={"content-creation-player-video"} style={{margin: 0, marginBottom: 30, maxWidth: "100%", justifyContent: "flex-start"}}>
                  {currentContentCreation.video ?
                    <ShakaPlayer
                      video={currentContentCreation.video}
                      videoTitle={currentContentCreation.title}
                      subtitles={currentContentCreation.video.subtitles}
                      thumbnail={currentContentCreation.image ? makeFitImageUrl(currentContentCreation, 500) : makeFitImageUrl({image: currentContentCreation.video.thumbnail}, 500)}
                      preview={false}
                      styles={{width: "100%", minWidth: window.innerWidth > 1440 ? 920 : window.innerWidth > 1280 ? 880 : window.innerWidth > 1024 ? 880 : window.innerWidth > 650 ? 600 : 0}}
                      autoPlay={false}
                      setAutoPlay={(value) => this.setState({autoPlay: value})}
                    />
                    : currentContentCreation.embededContent ?
                      <EmbededContent
                        content={currentContentCreation.embededContent}
                        index={currentContentCreation.id}
                        currentIndex={currentContentCreation.id}
                        width={window.innerWidth >= 1280 ? 920 : window.innerWidth >= 770 ? 580 : 275 }
                        height={window.innerWidth >= 1281 ? 520 : window.innerWidth >= 770 ? 475 : 175 }
                      /> :
                      currentContentCreation.audio ?
                      <div className="music-container"> 
                        <div className="music">
                          <div className="music-image-container">
                            <img alt="album" src={makeImageUrlWithSize(currentContentCreation, 'md')} />
                          </div>
                          <div className="music-details">
                            <div style={{ float: "left", position: "relative", width: "100%" }}>
                              <div className="music-title">{currentContentCreation.title}</div>
                              <div className="music-buttons">
                              </div>
                            </div>
                            <div style={{ float: "left", position: "relative", width: "100%" }}>
                              <Link onClick={() => this.soundbarRef && this.soundbarRef.stop()} to={homePathGenerator( `public/content_creators/${currentContentCreation.contentCreator.hashcode}`)} className="music-album">in {currentContentCreation.contentCreator.name}</Link>
                            </div>
                            {currentContentCreation.audio && currentContentCreation.audio.waveform &&
                            <div className="music-waveform">
                              <img alt="waveform" src={`${process.env.REACT_APP_CDN_HOST}/files/images/${currentContentCreation.audio.waveform.id}/crop/2000x70/waveform.png`} />
                            </div>
                            }
                          </div>
                        </div>
                        <SoundBar large style={{paddingTop: 30}} track={this.getAudio(currentContentCreation)} ref={r => this.soundbarRef = r}/>
                      </div>
                      :
                      currentContentCreation.image &&
                        <img
                          src={currentContentCreation ? makeFitImageUrlWithSize(currentContentCreation, 'lg') : ''}
                          className={"content-creation-player-image"}
                        />
                  }
                </div>
                {currentContentCreation.contentCreator && !currentContentCreation.audio &&
                <div className={"creation-info"}>
                  <div className={"creation-data"}>
                    <h3 style={{cursor: "pointer", marginTop: 0}}>{currentContentCreation.title}</h3>
                    <div className={"creation-author"}>
                      <div
                        className={"creation-author-image"}
                        style={{backgroundImage: `url(${!!currentContentCreation.contentCreator.image ? makeImageCarousel(currentContentCreation.contentCreator, {width: 15, height: 15, fit: false}) : NoProfile})`}}
                      />
                      <Link
                        className={"creation-author-name"}
                        to={homePathGenerator( `public/content_creators/${currentContentCreation.contentCreator.hashcode}`)}
                      >{currentContentCreation.contentCreator.name}</Link>
                    </div>
                  </div>
                </div>
                }
              </>
            }
          </RespD>
        </div>
        <PublicFooter {...this.props} style={{position: "absolute"}}/>
      </div>
    );
  };
}

export default PublicContentCreation;


const PublicContainer = styled.div`
  position: relative;
  float: left;
  width: 90%;
  margin: 8% 5% 2%;
  border: 1px solid;
  background: white;
  border-radius: 10px;
`
const RespD = styled.div`
  float: left;
  position: relative;
  padding: 30px 30px;
  width: 90%;
  margin: 10% 5%;
  background-color: white;
  @media (min-width: 640px) and (max-width: 800px) {
    padding: 8px;
    width: 98%;
    margin: 15% 1% 5%;
  }
  @media (max-width: 640px) {
    padding: 8px;
    width: 98%;
    margin: 50% 1% 5%;
  }
`;